import { render, staticRenderFns } from "./logout-menuTop.vue?vue&type=template&id=07046b9e&"
import script from "./logout-menuTop.vue?vue&type=script&lang=js&"
export * from "./logout-menuTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports